import { drawingStore } from "../store";

export const getIsHidden = () => {
  const state = drawingStore.reduxStore?.store?.getState();
  const selectors = drawingStore.reduxStore?.selectors;
  if (!state || !selectors) return;

  return selectors.getIsHidden(state);
};
